import { render, staticRenderFns } from "./free-search.vue?vue&type=template&id=f40a153e&scoped=true"
import script from "./free-search.vue?vue&type=script&lang=js"
export * from "./free-search.vue?vue&type=script&lang=js"
import style0 from "./free-search.vue?vue&type=style&index=0&id=f40a153e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40a153e",
  null
  
)

export default component.exports